import { getCookie } from '@app/services'
import { getActiveB2CCookieNames, getAuthMode } from '@app/utils'

import { AuthState } from './types'
import { vars } from '../../config'

export const getInitialAuthState = (): AuthState => {
  const { isBackOfficeTokenMode } = getAuthMode()
  const { accessTokenCookie, refreshTokenCookie } = getActiveB2CCookieNames()
  const token = isBackOfficeTokenMode
    ? getCookie(vars.b2b_access_token) || getCookie(accessTokenCookie)
    : getCookie(accessTokenCookie) || getCookie(vars.b2b_access_token)

  return {
    tokenData: {
      token,
      refresh_token: isBackOfficeTokenMode
        ? getCookie(vars.b2b_refresh_token) || getCookie(refreshTokenCookie)
        : getCookie(refreshTokenCookie) || getCookie(vars.b2b_refresh_token),
      urlToken: getCookie(vars.url_token),
      originalToken: getCookie(vars.ojwt),
    },
  }
}

export const initialState: AuthState = getInitialAuthState()
